export default {
  title: "Tours and experiences",
  subtitle: "Discover the best experiences in Baja California Sur",
  resultsCount: "{{count}} results found",
  resultsFound: "found",
  noResults: "No tours found",
  noResultsDesc: "Try adjusting your filters or search with different terms",
  clearFilters: "Clear filters",
  loading: "Loading...",
  loadError: "Could not load tours.",
  toursIn: "in",
  breadcrumb: {
    home: "Home",
    tours: "Tours",
  },
  search: {
    placeholder: "Search tours...",
    button: "Search",
  },
  sort: {
    label: "Sort by",
    recommended: "Recommended",
    priceLow: "Price: low to high",
    priceHigh: "Price: high to low",
    rating: "Top rated",
    newest: "Newest",
  },
  filters: {
    title: "Filters",
    price: "Price",
    minPrice: "Min",
    maxPrice: "Max",
    duration: "Duration",
    short: "Less than 2h",
    medium: "2h - 4h",
    long: "4h - 6h",
    fullDay: "More than 6h",
    rating: "Rating",
    excellent: "Excellent (4.5+)",
    veryGood: "Very good (4.0+)",
    good: "Good (3.5+)",
    language: "Tour language",
    spanish: "Spanish",
    english: "English",
    category: "Category",
    destination: "Destination",
  },
  card: {
    from: "From",
    perPerson: "per person",
    viewDetails: "View details",
    hours: "h",
    reviews: "reviews",
    save: "Save",
    bestRated: "Best rated",
  },
  pagination: {
    prev: "Previous",
    next: "Next",
    page: "Page",
    of: "of",
  },
  destinationPages: {
    aboutTitle: "About the destination",
    highlightsTitle: "Highlights",
    laPaz: {
      tagline: "The natural capital of Baja California Sur",
      desc: "The natural capital of Baja California Sur, where the sea meets the desert in perfect harmony. Discover pristine beaches, whale watching, snorkeling with sea lions and world-class cuisine.",
      fact1: "Capital of the state of Baja California Sur",
      fact2: "5 km boardwalk overlooking the Sea of Cortez",
      fact3: "Espíritu Santo Island: World Heritage Site",
      fact4: "Warm, dry climate all year round",
    },
    losCabos: {
      tagline: "Where the desert meets the sea",
      desc: "The luxury destination where the desert meets two seas. Enjoy world-class resorts, golf courses, sport fishing and stunning landscapes between Cabo San Lucas and San José del Cabo.",
      fact1: "33 km tourist corridor between the two Cabos",
      fact2: "More than 20 world-class golf courses",
      fact3: "Internationally renowned sport fishing",
      fact4: "El Arco: iconic rock formation",
    },
    caboSanLucas: {
      tagline: "The vibrant heart of Baja",
      desc: "The vibrant heart of Baja California Sur. Known for its nightlife, dream beaches, water sports and the iconic Arch at Land's End. A destination that combines adventure and relaxation.",
      fact1: "Southernmost tip of the peninsula",
      fact2: "Sea of Cortez and Pacific Ocean in one place",
      fact3: "Gray whale watching in winter",
      fact4: "Unique marine life: whale shark, manta rays",
    },
  },
};